"use client";

import Image from "next/image";

export default function Practice() {
  return (
    <div className="w-[90%] md:w-[80%] mx-auto py-2 md:py-10">
      <Image
        src="/images/learn.png"
        alt="Available seats"
        width={1200}
        height={600}
        className="mx-auto w-full h-auto object-contain hidden md:block"
        priority={false}
      />
      <Image
        src="/images/learnm.png"
        alt="Available seats"
        width={600}
        height={800}
        className="mx-auto w-full h-auto object-contain block md:hidden"
        priority={false}
      />
    </div>
  );
}